export default "__VITE_ASSET__BtDAURpq__"